export default function getRem(pixels) {
  return `${pixels / 16}rem`;
}
